var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19922 10.2V7.8C7.19922 5.148 9.34722 3 11.9992 3C14.6512 3 16.7992 5.148 16.7992 7.8V10.2",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4004 10.1992H6.60039C5.93765 10.1992 5.40039 10.7365 5.40039 11.3992V19.7992C5.40039 20.462 5.93765 20.9992 6.60039 20.9992H17.4004C18.0631 20.9992 18.6004 20.462 18.6004 19.7992V11.3992C18.6004 10.7365 18.0631 10.1992 17.4004 10.1992Z",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.8008V17.4008",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.9997129dfe8258178b3629552125ee09.svg";
export { ForwardRef as ReactComponent };